import React, { createContext, useState } from 'react';

import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

export const AccountManagementSecurityRolesStateContext = createContext();

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE
};

const AccountManagementSecurityRolesContextProvider = ({ children }) => {
  const stateHook = useState(INITIAL_STATE);

  return (
    <AccountManagementSecurityRolesStateContext.Provider value={stateHook}>
      {children}
    </AccountManagementSecurityRolesStateContext.Provider>
  );
};

export default AccountManagementSecurityRolesContextProvider;